export type CloudWorkspaceEntryView = "workspace" | "progress" | "unavailable";

/** A VM opens once its Environment delivers a ready snapshot. A new boot resets entry;
 * later reconnects remain inside the workspace, like other AFAR Environments. */
export function resolveCloudWorkspaceEntry(input: {
  /** The workspace was entered and has not booted again since. */
  readonly entered: boolean;
  readonly hasSnapshot: boolean;
  readonly shellReady: boolean;
  /** The workspace's machine is starting, so the connection waits on it. */
  readonly booting: boolean;
  /** The connection gave up on its own and its endpoint is not starting. */
  readonly unavailable: boolean;
}): { readonly view: CloudWorkspaceEntryView; readonly entered: boolean } {
  if (input.booting) return { view: "progress", entered: false };
  if (input.entered || (input.hasSnapshot && input.shellReady))
    return { view: "workspace", entered: true };
  if (!input.hasSnapshot && input.unavailable) return { view: "unavailable", entered: false };
  return { view: "progress", entered: false };
}
